import React from 'react'
import {PaletteColor} from '@mui/material'
import {Transaction} from '../../domain/Transaction'
import {TransactionDataGrid} from './TransactionDataGrid'
import {TransactionCardList} from './TransactionCardList'
import {useIsMobile} from '../../utils/useIsMobile'

export type MonthTransactionGridProps = {
  transactions: Transaction[],
  onTransactionUpdate: (updatedTransaction: Transaction) => void,
  onTransactionDelete: (transactionId: string) => void,
  monthColor: PaletteColor,
}

const MonthTransactionGrid: React.FC<MonthTransactionGridProps> = (props) => {
  const isMobile = useIsMobile()
  return isMobile ? <TransactionCardList {...props} /> : <TransactionDataGrid {...props} />
}

export default MonthTransactionGrid
